module.exports = __webpack_public_path__ + "assets/img/phone.2c851a5a.svg";